import React from 'react';
import './sectionOne.scss';
import laptopImg from '../../../resources/smartCommand/smart-command-1.png';

const SectionOne = () => {

    const handleDemoClick = () => {
        if (typeof document !== 'undefined') {
            window.location = '/contact';
        }
    };

    return (
        <div id='SmartCommandOne' className='SmartCommandOne'>
            <div className='SmartCommandOne-left'>
                <h4 className='SmartCommandOne-left-company-text'>
                    Enterprise Control Tower
                </h4>
                <h1 className='SmartCommandOne-left-heading'>
                    A real-time view of what matters, across your enterprise.
                </h1>
                <div className='SmartCommandOne-left-divider' />
                <p className='SmartCommandOne-left-text'>
                    Identify performance risks across revenue, margins, inventory, working capital, operations and customer service. Detect deviations, understand root causes, recommend interventions, assign accountability and measure realized impact.
                </p>
                <button
                    className='epm-hero__button epm-hero__button--primary'
                    style={{ width: '152px' }}
                    onClick={handleDemoClick}
                >
                    Schedule Demo
                </button>
            </div>
            <div className='SmartCommandOne-right'>
                <img
                    className='SmartCommandOne-right-bg-image'
                    src={laptopImg}
                    alt='Product Dashboard'
                />
            </div>
        </div>
    );
};

export default SectionOne;